import { GenerateTextConfig } from 'features/textGenerator/store/types';

export const getIsConfigEditable = ({ outputType, audienceId }: GenerateTextConfig) =>
  !!(audienceId && outputType);
